module.exports = __webpack_public_path__ + "img/item_icon1.99541274.png";